// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.

import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';
import type { AccountStickyLeftRailContainerProps } from './AccountStickyLeftRailContainer.types';

export const AccountStickyLeftRailContainer = dynamic(() =>
  import('./AccountStickyLeftRailContainer').then(mod => mod.AccountStickyLeftRailContainer)
);

export const AccountStickyLeftRailContainerConfig = {
  emptyLabel: 'Account Sticky Components Container',
  resourceType: ``,
  isEmpty: () => true,
};

export const AccountStickyLeftRailContainerEditable = (props: AccountStickyLeftRailContainerProps) => {
  return (
    <EditableComponent config={AccountStickyLeftRailContainerConfig} {...props}>
      <AccountStickyLeftRailContainer {...props} />
    </EditableComponent>
  );
};
